import React, { ReactElement, ReactNode } from 'react'

import useResponsive from 'hooks/useResponsive'

import BottomSheet from 'components/common/BottomSheet'
import Sheet from 'components/common/Sheet'

interface ResponsiveSheeetProps {
    onClose: () => void
    children: ReactNode
    showCloseButton?: boolean
    overlay?: boolean
}

const ResponsiveSheet = ({
    children,
    onClose,
    showCloseButton = true,
    overlay = true,
}: ResponsiveSheeetProps): ReactElement => {
    const { isMobile } = useResponsive()

    return isMobile ? (
        <BottomSheet
            isOpen={true}
            draggable={false}
            close={onClose}
            showCloseButton={showCloseButton}
            overlay={overlay}
        >
            {children}
        </BottomSheet>
    ) : (
        <Sheet onClose={onClose}>{children}</Sheet>
    )
}

export default ResponsiveSheet
